import birdsImg from "../../include/images/Birds.png";
import fishImg from "../../include/images/Fish.png";
import insectsImg from "../../include/images/Insects.png";
import mammalsImg from "../../include/images/Mammals.png";
import reefCoralsImg from "../../include/images/Reef Corals.png";
import reptilessImg from "../../include/images/Reptiles.png";
import sharksAndRaysImg from "../../include/images/Sharks & Rays.png";
import crustaceansImg from "../../include/images/Crustaceans.png";
import amphibiansImg from "../../include/images/Amphibians.png";
import defaultImage from "../../include/images/default_image_species.svg";

export const getDefaultImage = (fileName) => {
  switch (fileName) {
    case "birds":
      return birdsImg;
    case "amphibians":
      return amphibiansImg;
    case "fish":
      return fishImg;
    case "insects":
      return insectsImg;
    case "mammals":
      return mammalsImg;
    case "reef corals":
      return reefCoralsImg;
    case "reptiles":
      return reptilessImg;
    case "sharks & rays":
      return sharksAndRaysImg;
    case "crustaceans":
      return crustaceansImg;
    default:
      return defaultImage;
  }
};
